import { MutationKey } from '@tanstack/query-core';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { AppID, SpaceID } from '@playq/octopus-common';
import { PromotionSource } from '@playq/octopus2-apps-utility';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { experimentsQueryKeys } from '/api/hooks/experimentsService';
import { flowQueryKeys } from '/api/hooks/flows';
import { gameEventsQueryKeys } from '/api/hooks/gameEventsService';
import { snackbarService } from '/common/snackbarService';

import { spacePromotionsCloneKey } from './constants';

export type UseAppSpacePromotionsCloneParams = {
  appID: AppID;
  source: PromotionSource;
  targetSpaceID: SpaceID;
};

export const useAppSpacePromotionsClone = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, UseAppSpacePromotionsCloneParams>
) => {
  return useEitherMutation(
    ({ appID, source, targetSpaceID }) =>
      services2.spacesPromotionsService.clonePromotions(appID, source, targetSpaceID),
    {
      onSuccess: () => {
        snackbarService.success('All entities successfully cloned to selected space');
      },
      removeQueriesKeysArray: [experimentsQueryKeys, flowQueryKeys, gameEventsQueryKeys],
      mutationKey: spacePromotionsCloneKey as MutationKey,
      ...options,
    }
  );
};
